unit UMatModel;

interface

uses
  Js, UEssentialHelper, UResultModel;

type
  TMatModel = class
  private
    FBezeichnung: string;
    FId: Integer;
    FMeEinheit: string;
    FArtNr: string;
    FEan: string;
    FOnSuccess: TCallback;
    FOnError: TErrorEvent;
    FResult: TResultModel;
    procedure DoError(AMsg: string);
    procedure DoSuccess;
    procedure SetBezeichnung(const Value: string);
    procedure SetId(const Value: Integer);
    procedure SetMeEinheit(const Value: string);
    procedure SetArtNr(const Value: string);
    procedure SetEan(const Value: string);
    procedure SetOnError(const Value: TErrorEvent);
    procedure SetOnSuccess(const Value: TCallback);
    procedure SetResult(const Value: TResultModel);
  public
    constructor Create; overload;
    constructor Create(Json: string); overload;
    function Equals(Other: TMatModel): Boolean;
    function ToJson: string;
    function ToString: string; override;
    procedure ClearValues;
    procedure GetByCode(Url: string; ACode: string);
    procedure GetValueFrom(Other: TMatModel);
    procedure SetValues(Json: string); overload;
    procedure SetValues(Obj: TJsObject); overload;
    property Id: Integer read FId write SetId;
    property Bezeichnung: string read FBezeichnung write SetBezeichnung;
    property MeEinheit: string read FMeEinheit write SetMeEinheit;
    property ArtNr: string read FArtNr write SetArtNr;
    property Ean: string read FEan write SetEan;
    property OnSuccess: TCallback read FOnSuccess write SetOnSuccess;
    property OnError: TErrorEvent read FOnError write SetOnError;
    property Result: TResultModel read FResult write SetResult;
  end;

implementation

uses
  System.SysUtils, WebLib.Json, WebLib.REST, WebLib.Controls;

{ TMatModel }

procedure TMatModel.ClearValues;
begin
  Self.Id := 0;
  Self.Bezeichnung := '';
  Self.MeEinheit := '';
  Self.ArtNr := '';
  Self.Ean := '';
  Self.Result := nil;
end;

constructor TMatModel.Create;
begin
  Self.ClearValues;
  Self.OnSuccess := nil;
  Self.OnError := nil;
end;

constructor TMatModel.Create(Json: string);
begin
  Self.SetValues(Json);
  Self.OnSuccess := nil;
  Self.OnError := nil;
end;

procedure TMatModel.DoError(AMsg: string);
begin
  if Assigned(Self.OnError) then
    Self.OnError(Self, AMsg);
end;

procedure TMatModel.DoSuccess;
begin
  if Assigned(Self.OnSuccess) then
    Self.OnSuccess(Self);
end;

function TMatModel.Equals(Other: TMatModel): Boolean;
begin
  Result := true;
  if Other <> nil then
  begin
    Result := Result and (Self.Id = Other.Id);
    Result := Result and (Self.Bezeichnung = Other.Bezeichnung);
    Result := Result and (Self.MeEinheit = Other.MeEinheit);
    Result := Result and (Self.ArtNr = Other.ArtNr);
    Result := Result and (Self.Ean = Other.Ean);
  end
  else
    Result := false;
end;

procedure TMatModel.GetByCode(Url, ACode: string);
var
  Obj: TJsonObject;
  s: string;
  client: TRestClient;
  procedure HandlingError(Sender: TObject; ARequest: TJSXMLHttpRequestRecord;
    Event: TJSEventRecord; var Handled: Boolean);
  begin
    Handled := true;
    Self.DoError('Verbindungsfehler!');
  end;

  procedure HandlingResponse(Sender: TObject; AResponse: string);
  var
    jo: TJsObject;
  begin
    jo := TJsJson.parseObject(AResponse);
    Self.SetValues(string(jo['value']));
    if Self.Result.ResultValue then
      Self.DoSuccess
    else
      Self.DoError(Self.Result.ResultMessage);
  end;

begin
  Obj := TJsonObject.Create;
  Obj.AddPair('Code', ACode);
  s := Obj.ToJson;
  Obj := TJsonObject.Create;
  Obj.AddPair('value', s);
  client := TRestClient.Create(nil);
  client.OnError := HandlingError;
  client.OnResponse := HandlingResponse;
  client.HttpsPost(Url + '/MatService/GetByCode', 'application/json',
    Obj.ToJson);
end;

procedure TMatModel.GetValueFrom(Other: TMatModel);
begin
  if Other <> nil then
  begin
    Self.Id := Other.Id;
    Self.Bezeichnung := Other.Bezeichnung;
    Self.MeEinheit := Other.MeEinheit;
    Self.Ean := Other.Ean;
  end;
end;

procedure TMatModel.SetArtNr(const Value: string);
begin
  FArtNr := Value;
end;

procedure TMatModel.SetBezeichnung(const Value: string);
begin
  FBezeichnung := Value;
end;

procedure TMatModel.SetEan(const Value: string);
begin
  FEan := Value;
end;

procedure TMatModel.SetId(const Value: Integer);
begin
  FId := Value;
end;

procedure TMatModel.SetMeEinheit(const Value: string);
begin
  FMeEinheit := Value;
end;

procedure TMatModel.SetOnError(const Value: TErrorEvent);
begin
  FOnError := Value;
end;

procedure TMatModel.SetOnSuccess(const Value: TCallback);
begin
  FOnSuccess := Value;
end;

procedure TMatModel.SetResult(const Value: TResultModel);
begin
  FResult := Value;
end;

procedure TMatModel.SetValues(Obj: TJsObject);
begin
  Self.ClearValues;
  if Obj['Id'] <> nil then
    Self.Id := StrToInt(string(Obj['Id']));
  if Obj['Bezeichnung'] <> nil then
    Self.Bezeichnung := string(Obj['Bezeichnung']);
  if Obj['MeEinheit'] <> nil then
    Self.MeEinheit := string(Obj['MeEinheit']);
  if Obj['ArtNr'] <> nil then
    Self.ArtNr := string(Obj['ArtNr']);
  if Obj['Ean'] <> nil then
    Self.Ean := string(Obj['Ean']);
  if Obj['Result'] <> nil then
    Self.Result := TResultModel.Create(string(Obj['Result']));
end;

function TMatModel.ToJson: string;
var
  Obj: TJsonObject;
begin
  Obj := TJsonObject.Create;
  Obj.AddPair('Id', IntToStr(Self.Id));
  Obj.AddPair('Bezeichnung', Self.Bezeichnung);
  Obj.AddPair('MeEinheit', Self.MeEinheit);
  Obj.AddPair('ArtNr', Self.ArtNr);
  Obj.AddPair('Ean', Self.Ean);
  Result := Obj.ToString;
  Obj.Free;
end;

function TMatModel.ToString: string;
begin
  Result := Self.Bezeichnung;
  if Self.Id > 0 then
    Result := Result + ' [' + Self.MeEinheit + ']';
end;

procedure TMatModel.SetValues(Json: string);
var
  Obj: TJsObject;
begin
  Obj := TJsJson.parseObject(Json);
  Self.SetValues(Obj);
end;

end.
